const API_ENDPOINTS = {
  AUTH_LOGIN: "auth/login",
  AUTH_ME: "auth/me",
  AUTH_LOGOUT: "auth/logout",

  PLAN: "plans/",

  INDUSTRY: "industries/",
  INDUSTRY_TERMINOLOGY: (id: number) => `industries/${id}/terminology`,

  COMPANY: "companies/",
  COMPANY_STATS: "companies/stats",
  COMPANY_FLEET_OVERVIEW: "companies/fleet-overview",
  COMPANY_COMPLIANCE_OVERVIEW: "companies/compliance-overview",
  COMPANY_ONBOARDING_OVERVIEW: "companies/onboarding-overview",
  COMPANY_PIPELINE_OVERVIEW: "companies/pipeline-overview",
  COMPANY_TOGGLE_ACTIVE: (id: number) => `companies/${id}/toggle-active`,
  COMPANY_CHANGE_PLAN: (id: number) => `companies/${id}/plan`,
  COMPANY_EXTEND_TRIAL: (id: number) => `companies/${id}/extend-trial`,
  COMPANY_DELETE: (id: number) => `companies/${id}`,

  AUDIT_LOGS: "audit-logs/",

  ADMIN: "admins/",
  ADMIN_TOGGLE_ACTIVE: (id: number) => `admins/${id}/toggle-active`,

  ROLES_BY_COMPANY: (companyId: number) => `roles/company/${companyId}`,

  CUSTOM_FIELD_DEFINITIONS: "custom-fields/definitions",
  CUSTOM_FIELD_DEFINITION: (id: number) => `custom-fields/definitions/${id}`,
  CUSTOM_FIELD_VALUES: "custom-fields/values",
  CUSTOM_FIELD_VALUE: (id: number) => `custom-fields/values/${id}`,

  FEATURE_FLAG: "feature-flags/",
  FEATURE_FLAG_TOGGLE: (id: number) => `feature-flags/${id}/toggle`,

  APP_VERSION: "app-versions/",
  APP_VERSION_LATEST: (platform: string) => `app-versions/latest/${platform}`,

  BACKGROUND_JOB: "background-jobs/",
  BACKGROUND_JOB_CANCEL: (id: number) => `background-jobs/${id}/cancel`,
  BACKGROUND_JOB_RETRY: (id: number) => `background-jobs/${id}/retry`,

  DATA_EXPORT: "data-exports/",
  DATA_EXPORT_STATUS: (id: number) => `data-exports/${id}/status`,

  SYNC_QUEUE: "sync-queue/",

  RATE_LIMIT_LOG: "rate-limit-logs/",
  RATE_LIMIT_LOG_STATS: "rate-limit-logs/stats",

  COMPANY_USERS: (companyId: number) => `company-users/${companyId}/users`,
  COMPANY_USER_CREATE: (companyId: number) => `company-users/${companyId}/users/create`,
  COMPANY_USER_UPDATE: (companyId: number) => `company-users/${companyId}/users/update`,
  COMPANY_USER_DELETE: (companyId: number) => `company-users/${companyId}/users/delete`,
  COMPANY_CONFIG_BRANCHES: (companyId: number) => `company-config/${companyId}/branches`,
  COMPANY_CONFIG_BRANCH_CREATE: (cid: number) => `company-config/${cid}/branches/create`,
  COMPANY_CONFIG_BRANCH_UPDATE: (cid: number) => `company-config/${cid}/branches/update`,
  COMPANY_CONFIG_BRANCH_DELETE: (cid: number) => `company-config/${cid}/branches/delete`,
  COMPANY_CONFIG_DIVISIONS: (companyId: number) => `company-config/${companyId}/divisions`,
  COMPANY_CONFIG_DIVISION_CREATE: (cid: number) => `company-config/${cid}/divisions/create`,
  COMPANY_CONFIG_DIVISION_UPDATE: (cid: number) => `company-config/${cid}/divisions/update`,
  COMPANY_CONFIG_DIVISION_DELETE: (cid: number) => `company-config/${cid}/divisions/delete`,
  COMPANY_CONFIG_HOLIDAYS: (companyId: number) => `company-config/${companyId}/holidays`,
  COMPANY_CONFIG_HOLIDAY_CREATE: (cid: number) => `company-config/${cid}/holidays/create`,
  COMPANY_CONFIG_HOLIDAY_UPDATE: (cid: number) => `company-config/${cid}/holidays/update`,
  COMPANY_CONFIG_HOLIDAY_DELETE: (cid: number) => `company-config/${cid}/holidays/delete`,
  COMPANY_CONFIG_FEATURE_OVERRIDES: (companyId: number) => `company-config/${companyId}/feature-overrides`,
  COMPANY_CONFIG_USER_SKILLS: (companyId: number) => `company-config/${companyId}/user-skills`,
  COMPANY_CONFIG_TEAMS: (companyId: number) => `company-config/${companyId}/teams`,
  COMPANY_CONFIG_TEAM_CREATE: (cid: number) => `company-config/${cid}/teams/create`,
  COMPANY_CONFIG_TEAM_UPDATE: (cid: number) => `company-config/${cid}/teams/update`,
  COMPANY_CONFIG_TEAM_DELETE: (cid: number) => `company-config/${cid}/teams/delete`,
  COMPANY_CONFIG_TEAM_MEMBERS: (companyId: number, teamId: number) => `company-config/${companyId}/teams/${teamId}/members`,

  PUSH_TOKENS: "push-tokens/",
  PUSH_TOKEN_STATS: "push-tokens/stats",
  PUSH_TOKEN_DEACTIVATE: (id: number) => `push-tokens/${id}/deactivate`,

  CERTIFICATIONS: "certifications/",
  CERTIFICATION_DETAIL: (id: number) => `certifications/detail/${id}`,
  CERTIFICATION_CREATE: "certifications/create",
  CERTIFICATION_UPDATE: (id: number) => `certifications/update/${id}`,
  CERTIFICATION_DELETE: (id: number) => `certifications/delete/${id}`,

  // ── Company Inventory (platform) ──────────────────────────────────────────
  CI_SUPPLIERS:          (cid: number) => `company-inventory/${cid}/suppliers`,
  CI_SUPPLIER_CREATE:    (cid: number) => `company-inventory/${cid}/suppliers/create`,
  CI_SUPPLIER_UPDATE:    (cid: number) => `company-inventory/${cid}/suppliers/update`,
  CI_SUPPLIER_DELETE:    (cid: number) => `company-inventory/${cid}/suppliers/delete`,
  CI_CATEGORIES:         (cid: number) => `company-inventory/${cid}/categories`,
  CI_CATEGORY_CREATE:    (cid: number) => `company-inventory/${cid}/categories/create`,
  CI_CATEGORY_UPDATE:    (cid: number) => `company-inventory/${cid}/categories/update`,
  CI_CATEGORY_DELETE:    (cid: number) => `company-inventory/${cid}/categories/delete`,
  CI_PARTS:              (cid: number) => `company-inventory/${cid}/parts`,
  CI_PART_CREATE:        (cid: number) => `company-inventory/${cid}/parts/create`,
  CI_PART_UPDATE:        (cid: number) => `company-inventory/${cid}/parts/update`,
  CI_PART_DELETE:        (cid: number) => `company-inventory/${cid}/parts/delete`,
  CI_LOCATIONS:          (cid: number) => `company-inventory/${cid}/locations`,
  CI_LOCATION_CREATE:    (cid: number) => `company-inventory/${cid}/locations/create`,
  CI_LOCATION_UPDATE:    (cid: number) => `company-inventory/${cid}/locations/update`,
  CI_LOCATION_DELETE:    (cid: number) => `company-inventory/${cid}/locations/delete`,
  CI_LEVELS:             (cid: number) => `company-inventory/${cid}/levels`,
  CI_MOVEMENTS:          (cid: number) => `company-inventory/${cid}/movements`,
  CI_MOVEMENT_CREATE:    (cid: number) => `company-inventory/${cid}/movements/create`,

  // ── Company Vehicles (platform) ───────────────────────────────────────────
  CV_LIST:               (cid: number) => `company-vehicles/${cid}/list`,
  CV_CREATE:             (cid: number) => `company-vehicles/${cid}/create`,
  CV_UPDATE:             (cid: number) => `company-vehicles/${cid}/update`,
  CV_DELETE:             (cid: number) => `company-vehicles/${cid}/delete`,
  CV_DEFECTS:            (cid: number) => `company-vehicles/${cid}/defects`,
  CV_DEFECT_RESOLVE:     (cid: number) => `company-vehicles/${cid}/defects/resolve`,
  CV_MILEAGE:            (cid: number) => `company-vehicles/${cid}/mileage`,
  CV_MILEAGE_CREATE:     (cid: number) => `company-vehicles/${cid}/mileage/create`,

  // ── Company Finance (platform) ────────────────────────────────────────────
  CF_INVOICES:           (cid: number) => `company-finance/${cid}/invoices`,
  CF_INVOICE_STATS:      (cid: number) => `company-finance/${cid}/invoices/stats`,
  CF_INVOICE_DETAIL:     (cid: number, id: number) => `company-finance/${cid}/invoices/${id}`,
  CF_INVOICE_CREATE:     (cid: number) => `company-finance/${cid}/invoices/create`,
  CF_INVOICE_UPDATE:     (cid: number) => `company-finance/${cid}/invoices/update`,
  CF_INVOICE_DELETE:     (cid: number) => `company-finance/${cid}/invoices/delete`,
  CF_INVOICE_STATUS:     (cid: number) => `company-finance/${cid}/invoices/status`,
  CF_INVOICE_PAYMENT:    (cid: number) => `company-finance/${cid}/invoices/payment`,

  CF_QUOTES:             (cid: number) => `company-finance/${cid}/quotes`,
  CF_QUOTE_STATS:        (cid: number) => `company-finance/${cid}/quotes/stats`,
  CF_QUOTE_DETAIL:       (cid: number, id: number) => `company-finance/${cid}/quotes/${id}`,
  CF_QUOTE_CREATE:       (cid: number) => `company-finance/${cid}/quotes/create`,
  CF_QUOTE_UPDATE:       (cid: number) => `company-finance/${cid}/quotes/update`,
  CF_QUOTE_DELETE:       (cid: number) => `company-finance/${cid}/quotes/delete`,
  CF_QUOTE_SEND:         (cid: number) => `company-finance/${cid}/quotes/send`,

  CF_POS:                (cid: number) => `company-finance/${cid}/pos`,
  CF_PO_STATS:           (cid: number) => `company-finance/${cid}/pos/stats`,
  CF_PO_DETAIL:          (cid: number, id: number) => `company-finance/${cid}/pos/${id}`,
  CF_PO_CREATE:          (cid: number) => `company-finance/${cid}/pos/create`,
  CF_PO_UPDATE:          (cid: number) => `company-finance/${cid}/pos/update`,
  CF_PO_DELETE:          (cid: number) => `company-finance/${cid}/pos/delete`,
  CF_PO_STATUS:          (cid: number) => `company-finance/${cid}/pos/status`,
  CF_PO_CANCEL:          (cid: number) => `company-finance/${cid}/pos/cancel`,

  CF_FIN_CLIENTS:        (cid: number) => `company-finance/${cid}/clients`,
  CF_FIN_SUPPLIERS:      (cid: number) => `company-finance/${cid}/suppliers`,
  CF_FIN_USERS:          (cid: number) => `company-finance/${cid}/users`,

  // ── Company Jobs (platform) ───────────────────────────────────────────────
  CJ_JOBS_LIST:           (cid: number) => `company-jobs/${cid}/list`,
  CJ_JOBS_CREATE:         (cid: number) => `company-jobs/${cid}/create`,
  CJ_JOBS_UPDATE:         (cid: number) => `company-jobs/${cid}/update`,
  CJ_JOBS_DELETE:         (cid: number) => `company-jobs/${cid}/delete`,
  CJ_JOBS_CLIENTS:        (cid: number) => `company-jobs/${cid}/clients`,
  CJ_JOBS_USERS:          (cid: number) => `company-jobs/${cid}/users`,
  CJ_JOBS_CF_DEFS:        (cid: number) => `company-jobs/${cid}/cf-defs`,
  CJ_JOBS_CF_VALUES:      (cid: number, jobId: number) => `company-jobs/${cid}/cf-values/${jobId}`,
  CJ_JOBS_CF_VALUES_SAVE: (cid: number) => `company-jobs/${cid}/cf-values`,
  CJ_JOBS_FORMS:                  (cid: number) => `company-jobs/${cid}/form-templates`,
  CJ_JOBS_FORM_DETAIL:            (cid: number, id: number) => `company-jobs/${cid}/form-templates/${id}`,
  CJ_JOBS_FORM_RESPONSES:         (cid: number, jobId: number) => `company-jobs/${cid}/form-responses/${jobId}`,
  CJ_JOBS_FORM_SAVE:              (cid: number) => `company-jobs/${cid}/form-responses`,

  // Job tasks
  CJ_TASKS:                       (cid: number, jobId: number) => `company-jobs/${cid}/tasks/${jobId}`,
  CJ_TASK_CREATE:                 (cid: number) => `company-jobs/${cid}/tasks/create`,
  CJ_TASK_UPDATE:                 (cid: number) => `company-jobs/${cid}/tasks/update`,
  CJ_TASK_DELETE:                 (cid: number) => `company-jobs/${cid}/tasks/delete`,

  // Checklists
  CJ_CHECKLIST_TEMPLATES:         (cid: number) => `company-jobs/${cid}/checklist-templates`,
  CJ_CHECKLIST_RESPONSES:         (cid: number, jobId: number) => `company-jobs/${cid}/checklist-responses/${jobId}`,
  CJ_CHECKLIST_RESPONSE_SAVE:     (cid: number) => `company-jobs/${cid}/checklist-responses/save`,

  // Employee locations
  CJ_EMPLOYEE_LOCATIONS:          (cid: number) => `company-jobs/${cid}/employee-locations`,
  CJ_EMPLOYEE_LOCATION_UPSERT:    (cid: number) => `company-jobs/${cid}/employee-locations/upsert`,

  // Finance: PO list for invoice creation
  CF_PO_LIST_FOR_INVOICE:         (cid: number) => `company-finance/${cid}/pos`,

  // ── Company Job Config (platform) ─────────────────────────────────────────
  CJ_JOB_TYPES:          (cid: number) => `company-job-config/${cid}/job-types`,
  CJ_JOB_TYPE_CREATE:    (cid: number) => `company-job-config/${cid}/job-types/create`,
  CJ_JOB_TYPE_UPDATE:    (cid: number) => `company-job-config/${cid}/job-types/update`,
  CJ_JOB_TYPE_DELETE:    (cid: number) => `company-job-config/${cid}/job-types/delete`,
  CJ_PIPELINES:          (cid: number) => `company-job-config/${cid}/pipelines`,
  CJ_PIPELINE_CREATE:    (cid: number) => `company-job-config/${cid}/pipelines/create`,
  CJ_STAGE_CREATE:       (cid: number) => `company-job-config/${cid}/stages/create`,
  CJ_CHECKLISTS:         (cid: number) => `company-job-config/${cid}/checklists`,
  CJ_CHECKLIST_DETAIL:   (cid: number, id: number) => `company-job-config/${cid}/checklists/${id}`,
  CJ_CHECKLIST_CREATE:   (cid: number) => `company-job-config/${cid}/checklists/create`,
  CJ_CHECKLIST_UPDATE:   (cid: number) => `company-job-config/${cid}/checklists/update`,
  CJ_CHECKLIST_DELETE:   (cid: number) => `company-job-config/${cid}/checklists/delete`,
  CJ_FORMS:              (cid: number) => `company-job-config/${cid}/forms`,
  CJ_FORM_DETAIL:        (cid: number, id: number) => `company-job-config/${cid}/forms/${id}`,
  CJ_FORM_CREATE:        (cid: number) => `company-job-config/${cid}/forms/create`,
  CJ_FORM_UPDATE:        (cid: number) => `company-job-config/${cid}/forms/update`,
  CJ_FORM_DELETE:        (cid: number) => `company-job-config/${cid}/forms/delete`,

  // Form sections
  CJ_SECTION_CREATE:     (cid: number, formId: number) => `company-job-config/${cid}/forms/${formId}/sections/create`,
  CJ_SECTION_UPDATE:     (cid: number, formId: number) => `company-job-config/${cid}/forms/${formId}/sections/update`,
  CJ_SECTION_DELETE:     (cid: number, formId: number) => `company-job-config/${cid}/forms/${formId}/sections/delete`,

  // Form fields
  CJ_FIELD_CREATE:       (cid: number, formId: number, sectionId: number) => `company-job-config/${cid}/forms/${formId}/sections/${sectionId}/fields/create`,
  CJ_FIELD_UPDATE:       (cid: number, formId: number, sectionId: number) => `company-job-config/${cid}/forms/${formId}/sections/${sectionId}/fields/update`,
  CJ_FIELD_DELETE:       (cid: number, formId: number, sectionId: number) => `company-job-config/${cid}/forms/${formId}/sections/${sectionId}/fields/delete`,

  // Checklist items
  CJ_ITEM_CREATE:        (cid: number, clId: number) => `company-job-config/${cid}/checklists/${clId}/items/create`,
  CJ_ITEM_UPDATE:        (cid: number, clId: number) => `company-job-config/${cid}/checklists/${clId}/items/update`,
  CJ_ITEM_DELETE:        (cid: number, clId: number) => `company-job-config/${cid}/checklists/${clId}/items/delete`,

  // ── Company Clients ────────────────────────────────────────────────────────
  CLI_LIST:    (cid: number) => `company-clients/${cid}/list`,
  CLI_DETAIL:  (cid: number, id: number) => `company-clients/${cid}/detail/${id}`,
  CLI_CREATE:  (cid: number) => `company-clients/${cid}/create`,
  CLI_UPDATE:  (cid: number) => `company-clients/${cid}/update`,
  CLI_DELETE:  (cid: number) => `company-clients/${cid}/delete`,

  // ── Company Compliance / UK Section 17 (platform) ─────────────────────────
  CC_USERS:                    (cid: number) => `company-compliance/${cid}/users`,
  CC_CLIENTS:                  (cid: number) => `company-compliance/${cid}/clients`,
  CC_CERT_TYPES:               (cid: number) => `company-compliance/${cid}/cert-types`,
  CC_CERT_TYPE_CREATE:         (cid: number) => `company-compliance/${cid}/cert-types/create`,
  CC_CERT_TYPE_UPDATE:         (cid: number) => `company-compliance/${cid}/cert-types/update`,
  CC_CERT_TYPE_DELETE:         (cid: number) => `company-compliance/${cid}/cert-types/delete`,
  CC_WORKER_CERTS:             (cid: number) => `company-compliance/${cid}/worker-certs`,
  CC_WORKER_CERT_CREATE:       (cid: number) => `company-compliance/${cid}/worker-certs/create`,
  CC_WORKER_CERT_UPDATE:       (cid: number) => `company-compliance/${cid}/worker-certs/update`,
  CC_WORKER_CERT_DELETE:       (cid: number) => `company-compliance/${cid}/worker-certs/delete`,
  CC_RTW:                      (cid: number) => `company-compliance/${cid}/rtw`,
  CC_RTW_CREATE:               (cid: number) => `company-compliance/${cid}/rtw/create`,
  CC_RTW_UPDATE:               (cid: number) => `company-compliance/${cid}/rtw/update`,
  CC_RTW_DELETE:               (cid: number) => `company-compliance/${cid}/rtw/delete`,
  CC_DBS:                      (cid: number) => `company-compliance/${cid}/dbs`,
  CC_DBS_CREATE:               (cid: number) => `company-compliance/${cid}/dbs/create`,
  CC_DBS_UPDATE:               (cid: number) => `company-compliance/${cid}/dbs/update`,
  CC_DBS_DELETE:               (cid: number) => `company-compliance/${cid}/dbs/delete`,
  CC_IR35:                     (cid: number) => `company-compliance/${cid}/ir35`,
  CC_IR35_CREATE:              (cid: number) => `company-compliance/${cid}/ir35/create`,
  CC_IR35_UPDATE:              (cid: number) => `company-compliance/${cid}/ir35/update`,
  CC_IR35_DELETE:              (cid: number) => `company-compliance/${cid}/ir35/delete`,
  CC_CIS_RECORDS:              (cid: number) => `company-compliance/${cid}/cis-records`,
  CC_CIS_RECORD_CREATE:        (cid: number) => `company-compliance/${cid}/cis-records/create`,
  CC_CIS_RECORD_UPDATE:        (cid: number) => `company-compliance/${cid}/cis-records/update`,
  CC_CIS_RECORD_DELETE:        (cid: number) => `company-compliance/${cid}/cis-records/delete`,
  CC_CIS_STATEMENTS:           (cid: number) => `company-compliance/${cid}/cis-statements`,
  CC_CIS_STATEMENT_CREATE:     (cid: number) => `company-compliance/${cid}/cis-statements/create`,
  CC_CIS_STATEMENT_DELETE:     (cid: number) => `company-compliance/${cid}/cis-statements/delete`,
  CC_CIS_RETURNS:              (cid: number) => `company-compliance/${cid}/cis-returns`,
  CC_CIS_RETURN_CREATE:        (cid: number) => `company-compliance/${cid}/cis-returns/create`,
  CC_CIS_RETURN_UPDATE:        (cid: number) => `company-compliance/${cid}/cis-returns/update`,
  CC_CIS_RETURN_DELETE:        (cid: number) => `company-compliance/${cid}/cis-returns/delete`,
  CC_COSHH_SUBSTANCES:         (cid: number) => `company-compliance/${cid}/coshh-substances`,
  CC_COSHH_SUBSTANCE_CREATE:   (cid: number) => `company-compliance/${cid}/coshh-substances/create`,
  CC_COSHH_SUBSTANCE_UPDATE:   (cid: number) => `company-compliance/${cid}/coshh-substances/update`,
  CC_COSHH_SUBSTANCE_DELETE:   (cid: number) => `company-compliance/${cid}/coshh-substances/delete`,
  CC_COSHH_ASSESSMENTS:        (cid: number) => `company-compliance/${cid}/coshh-assessments`,
  CC_COSHH_ASSESSMENT_CREATE:  (cid: number) => `company-compliance/${cid}/coshh-assessments/create`,
  CC_COSHH_ASSESSMENT_UPDATE:  (cid: number) => `company-compliance/${cid}/coshh-assessments/update`,
  CC_COSHH_ASSESSMENT_DELETE:  (cid: number) => `company-compliance/${cid}/coshh-assessments/delete`,
  CC_ACCIDENTS:                (cid: number) => `company-compliance/${cid}/accidents`,
  CC_ACCIDENT_CREATE:          (cid: number) => `company-compliance/${cid}/accidents/create`,
  CC_ACCIDENT_UPDATE:          (cid: number) => `company-compliance/${cid}/accidents/update`,
  CC_ACCIDENT_DELETE:          (cid: number) => `company-compliance/${cid}/accidents/delete`,
  CC_LONE_WORKER:              (cid: number) => `company-compliance/${cid}/lone-worker`,
  CC_LONE_WORKER_CHECKINS:     (cid: number, sid: number) => `company-compliance/${cid}/lone-worker/${sid}/checkins`,
  CC_LONE_WORKER_CREATE:       (cid: number) => `company-compliance/${cid}/lone-worker/create`,
  CC_LONE_WORKER_UPDATE:       (cid: number) => `company-compliance/${cid}/lone-worker/update`,
  CC_LONE_WORKER_DELETE:       (cid: number) => `company-compliance/${cid}/lone-worker/delete`,
  CC_INSURANCES:               (cid: number) => `company-compliance/${cid}/insurances`,
  CC_INSURANCE_CREATE:         (cid: number) => `company-compliance/${cid}/insurances/create`,
  CC_INSURANCE_UPDATE:         (cid: number) => `company-compliance/${cid}/insurances/update`,
  CC_INSURANCE_DELETE:         (cid: number) => `company-compliance/${cid}/insurances/delete`,
  CC_SCAFFOLD:                 (cid: number) => `company-compliance/${cid}/scaffold`,
  CC_SCAFFOLD_INSPECTIONS:     (cid: number, sid: number) => `company-compliance/${cid}/scaffold/${sid}/inspections`,
  CC_SCAFFOLD_CREATE:          (cid: number) => `company-compliance/${cid}/scaffold/create`,
  CC_SCAFFOLD_UPDATE:          (cid: number) => `company-compliance/${cid}/scaffold/update`,
  CC_SCAFFOLD_DELETE:          (cid: number) => `company-compliance/${cid}/scaffold/delete`,
  CC_SCAFFOLD_INSPECTION_CREATE: (cid: number) => `company-compliance/${cid}/scaffold/inspection/create`,
  CC_SCAFFOLD_INSPECTION_DELETE: (cid: number) => `company-compliance/${cid}/scaffold/inspection/delete`,
  CC_WASTE_LICENCES:           (cid: number) => `company-compliance/${cid}/waste-licences`,
  CC_WASTE_LICENCE_CREATE:     (cid: number) => `company-compliance/${cid}/waste-licences/create`,
  CC_WASTE_LICENCE_UPDATE:     (cid: number) => `company-compliance/${cid}/waste-licences/update`,
  CC_WASTE_LICENCE_DELETE:     (cid: number) => `company-compliance/${cid}/waste-licences/delete`,
  CC_WASTE_TRANSFERS:          (cid: number) => `company-compliance/${cid}/waste-transfers`,
  CC_WASTE_TRANSFER_CREATE:    (cid: number) => `company-compliance/${cid}/waste-transfers/create`,
  CC_WASTE_TRANSFER_DELETE:    (cid: number) => `company-compliance/${cid}/waste-transfers/delete`,

  // ── HR / Payroll (Section 18) ──────────────────────────────────────────────
  HR_USERS:                (cid: number) => `company-hr/${cid}/users`,
  HR_LEAVE:                (cid: number) => `company-hr/${cid}/leave`,
  HR_HOLIDAY:              (cid: number) => `company-hr/${cid}/holiday`,
  HR_SICKNESS:             (cid: number) => `company-hr/${cid}/sickness`,
  HR_STATUTORY:            (cid: number) => `company-hr/${cid}/statutory`,
  HR_TIMESHEETS:           (cid: number) => `company-hr/${cid}/timesheets`,
  HR_TIMESHEET_ENTRIES:    (cid: number, tsId: number) => `company-hr/${cid}/timesheets/${tsId}/entries`,
  HR_TIMESHEET_ENTRY_DEL:  (cid: number) => `company-hr/${cid}/timesheet-entries`,
  HR_NMW_RATES:            () => `company-hr/nmw-rates`,
  HR_NMW_CHECKS:           (cid: number) => `company-hr/${cid}/nmw-checks`,
  HR_PENSION_SETTINGS:     (cid: number) => `company-hr/${cid}/pension-settings`,
  HR_PENSION_ENROLMENTS:   (cid: number) => `company-hr/${cid}/pension-enrolments`,

  // ── Documents & Certs (Section 21) ────────────────────────────────────────
  DOC_CLIENTS:             (cid: number) => `company-documents/${cid}/clients`,
  DOC_FOLDERS:             (cid: number) => `company-documents/${cid}/folders`,
  DOC_FILES:               (cid: number) => `company-documents/${cid}/files`,
  DOC_CERT_TEMPLATES:      (cid: number) => `company-documents/${cid}/cert-templates`,
  DOC_CERTIFICATES:        (cid: number) => `company-documents/${cid}/certificates`,
  DOC_FEEDBACK:            (cid: number) => `company-documents/${cid}/feedback`,
  DOC_TENDERS:             (cid: number) => `company-documents/${cid}/tenders`,
  DOC_CONTRACTS:           (cid: number) => `company-documents/${cid}/contracts`,

  // ── Integrations (Section 23) ─────────────────────────────────────────────
  INT_LIST:                (cid: number) => `company-integrations/${cid}/list`,
  INT_UPSERT:              (cid: number) => `company-integrations/${cid}/upsert`,
  INT_DISCONNECT:          (cid: number, id: number) => `company-integrations/${cid}/${id}/disconnect`,
  INT_DELETE:              (cid: number, id: number) => `company-integrations/${cid}/${id}`,

  // ── PQQ & Procurement (Section 24) ────────────────────────────────────────
  PQQ_LIST:                (cid: number) => `company-pqq/${cid}/list`,
  PQQ_CREATE:              (cid: number) => `company-pqq/${cid}/create`,
  PQQ_UPDATE:              (cid: number, id: number) => `company-pqq/${cid}/${id}`,
  PQQ_DELETE:              (cid: number, id: number) => `company-pqq/${cid}/${id}`,

  // ── Platform Billing (Section 25) ─────────────────────────────────────────
  BILLING_INVOICES:        (cid: number) => `platform-billing/${cid}/invoices`,
  BILLING_INVOICE_CREATE:  (cid: number) => `platform-billing/${cid}/invoices`,
  BILLING_INVOICE_STATUS:  (cid: number, id: number) => `platform-billing/${cid}/invoices/${id}/status`,

  // ── System Announcements (Section 25) ─────────────────────────────────────
  ANNOUNCEMENTS:           "announcements/",
  ANNOUNCEMENT_UPDATE:     (id: number) => `announcements/${id}`,
  ANNOUNCEMENT_DELETE:     (id: number) => `announcements/${id}`,

  // ── RBAC ──────────────────────────────────────────────────────────────────
  ROLES_PERMISSIONS:       "roles/permissions",
  ROLES_CREATE:            (companyId: number) => `roles/company/${companyId}`,
  ROLES_UPDATE_PERMS:      (roleId: number) => `roles/${roleId}/permissions`,
  ROLES_DELETE:            (roleId: number) => `roles/${roleId}`,
};

export default API_ENDPOINTS;
